import {
  WorksheetBatchUpdateCommonDefaultParams,
  WorksheetBatchUpdateCommonQueryFields,
  WorksheetBatchUpdateCommonRequiredParams,
} from 'Components/WorksheetBatchUpdate/Core/SharedQueryFields';
import { WorksheetBatchUpdateDefinition } from '../..';
import { IhmHandShearVaneWorksheetFields, IhmHandShearVaneWorksheetSections } from './IhmHandShearVaneWorksheetFields';

const IhmHandShearVaneBatchUpdateDefinition: WorksheetBatchUpdateDefinition = {
  worksheetType: 'Hand Shear Vane',
  query: {
    defaultParams: WorksheetBatchUpdateCommonDefaultParams,
    requiredParams: WorksheetBatchUpdateCommonRequiredParams,
  },
  queryFields: WorksheetBatchUpdateCommonQueryFields,
  worksheetFields: IhmHandShearVaneWorksheetFields,
  worksheetFieldSections: IhmHandShearVaneWorksheetSections,
};

export default IhmHandShearVaneBatchUpdateDefinition;

export { IhmHandShearVaneBatchUpdateDefinition };
